import { useState } from "react";
import { Provider } from "react-redux";
import { JssProvider } from "react-jss";
import { PersistGate } from "redux-persist/integration/react";

import MainContainer from "./containers/main-container";
import FatalErrorMessage from "./components/common/error/fatal-error-message";
import { isMobileDevice } from "./utils/device-helper";
import useThemeStyles from "./utils/theme-utils/useThemeStyles";
import createGenerateId from "./utils/jss-helper";
import SelectTheme from "./components/demo/select-theme";
import SelectSkin from "./components/demo/select-skin";

const generateId = createGenerateId();

const App = (props) => {
  const {
    configurationSettings,
    groceryCrudPersistor,
    groceryCrudStore,
    loadCssIcons,
    loadCssTheme,
    loadCssThirdParty,
    publishEvents,
    settings,
    showThemeSwitcher = false,
    skin: skinProp,
    theme: themeProp,
  } = props;

  const [theme, setTheme] = useState(themeProp);

  const [skin, setSkin] = useState(skinProp);

  useThemeStyles(skin);

  try {
    const MainContainerWithTheme = () => (
      <MainContainer
        isMobileDevice={isMobileDevice()}
        loadCssIcons={loadCssIcons}
        loadCssTheme={loadCssTheme}
        loadCssThirdParty={loadCssThirdParty}
        settings={settings}
        skin={skin}
        theme={theme}
        configurationSettings={configurationSettings}
        publishEvents={publishEvents}
      />
    );

    return (
      <>
        <JssProvider generateId={generateId}>
          <Provider store={groceryCrudStore}>
            {groceryCrudPersistor ? (
              <>
                <PersistGate loading={null} persistor={groceryCrudPersistor}>
                  <MainContainerWithTheme />
                </PersistGate>
              </>
            ) : (
              <MainContainerWithTheme />
            )}
          </Provider>
        </JssProvider>
        {showThemeSwitcher && (
          <>
            <SelectTheme setTheme={setTheme} theme={theme} />
            <SelectSkin setSkin={setSkin} skin={skin} />
          </>
        )}
      </>
    );
  } catch (error) {
    console.log(error);
    return <FatalErrorMessage />;
  }
};

export default App;
